import { render, staticRenderFns } from "./RightsFundRollbackCopy.vue?vue&type=template&id=eb8a890a"
import script from "./RightsFundRollbackCopy.vue?vue&type=script&lang=js"
export * from "./RightsFundRollbackCopy.vue?vue&type=script&lang=js"
import style0 from "./RightsFundRollbackCopy.vue?vue&type=style&index=0&id=eb8a890a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports